const $ = window.jQuery;
const ExampleComponent1 = {

    init () {
        $('.toggle').click(function(e) {
            e.preventDefault();
        
          var $this = $(this);
        
          if ($this.next().hasClass('show')) {
              $this.next().removeClass('show');
              $this.next().slideUp(350);
          } else {
              $this.parent().find('li .inner-block').removeClass('show');
              $this.parent().find('li .inner-block').slideUp(350);
              $this.next().toggleClass('show');
              $this.next().slideToggle(350);
          }
      });
      if (sessionStorage.getItem('prep') === null) {
        $('.prepage-ps').fadeIn();
      }
      else{
        $('.prepage-ps').fadeOut();
      }
      $('.close-prepage').click(function(){
            sessionStorage.setItem('prep', 'true');

            $('.prepage-ps').fadeOut();

      });
      $('.add-ct-btn').click(function(e) {
       
        $('.widget_shopping_cart_content_ps').fadeIn();
      });
    },
};

export default ExampleComponent1;